import api from '../../service/api';

export const getChart = async (name, filter, filterDate) => await api.post(`/campaign/active/histogram`, { key: name, filter: filter, filter_date: filterDate });
export const getData = async () => await api.get(`/account/metrics`);

